import { render, staticRenderFns } from "./ContactCardLink.vue?vue&type=template&id=7d06b050&scoped=true"
import script from "./ContactCardLink.vue?vue&type=script&lang=js"
export * from "./ContactCardLink.vue?vue&type=script&lang=js"
import style0 from "./ContactCardLink.vue?vue&type=style&index=0&id=7d06b050&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06b050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d06b050')) {
      api.createRecord('7d06b050', component.options)
    } else {
      api.reload('7d06b050', component.options)
    }
    module.hot.accept("./ContactCardLink.vue?vue&type=template&id=7d06b050&scoped=true", function () {
      api.rerender('7d06b050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Contact/ContactCardLink.vue"
export default component.exports